import i18n from "i18next";
import React from "react";

const DataGridNoResult = () => (
  <div className="data-grid__nothing">
    <span className="data-grid__nothing-title">{i18n.t("table.nothing")}</span>
    <span className="data-grid__nothing-result">{i18n.t("table.noResult")}</span>
  </div>
);

export default DataGridNoResult;



// WEBPACK FOOTER //
// ./src/components/Layout/DataGrid/DataGridNoResult.js